import { render, staticRenderFns } from "./ListDiseases.vue?vue&type=template&id=3a47b235&scoped=true&"
import script from "./ListDiseases.vue?vue&type=script&lang=js&"
export * from "./ListDiseases.vue?vue&type=script&lang=js&"
import style0 from "./ListDiseases.vue?vue&type=style&index=0&id=3a47b235&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a47b235",
  null
  
)

export default component.exports